// src/components/MissionVision.js
import React from 'react';
import { motion } from 'framer-motion';

// ده الـ CSS (ممكن تضيفه في ملف App.css)
/*
.mission-vision-container {
  display: grid;
  grid-template-columns: 1fr 1fr; // عمودين
  gap: 30px;
  margin: 30px 0;
}
.mv-card {
  background: #fff;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}
.mv-card h2 {
  border-bottom: 2px solid #0056b3; // لون البراند
  padding-bottom: 10px;
}
*/

function MissionVision({ mission, vision }) {
  return (
    <div className="mission-vision-container">
      <div className="mv-card">
        <h2>رسالتنا</h2>
        <p>{mission}</p>
      </div>
      <div className="mv-card">
        <h2>رؤيتنا</h2>
        <p>{vision}</p>
      </div>
    </div>
  );
}

export default MissionVision;